import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  Tooltip,
  Divider,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { ChromePicker } from "react-color";
import {
  POS_RIGHT_MIDDLE,
  POS_RIGHT_BOTTOM,
  POS_LEFT_MIDDLE,
  POS_LEFT_BOTTOM,
  POS_BOTTOM_RIGHT,
  POS_BOTTOM_LEFT,
  POS_CUSTOM,
  IProductParams,
  ICustomProperties,
  MAIN_BUTTON,
  FEEDBACK_TYPE_FEEDBACK,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  PLATFORM_TYPE_TV,
} from "../../../model";
import IconUpload from "./iconUpload";
import useClickOutside from "./useClickOutside";
import HelpIcon from "@mui/icons-material/Help";
import { UserContext } from "../../../context/userContext";
import { UserLoginInfo } from "../../../types/context";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { appLogger } from "../../../utils";
import BrandingAgent from "./BrandingAgent";

import { cloneDeep } from "lodash";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const WidgetAppearance = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "WidgetAppearance",
      component: "add-product",
      fileName: "widgetAppearance.tsx",
      props: props,
    },
  });
  const {
    setWidgetVal,
    productParams,
    setProductParams,
    setScroll,
    setpreviewScroll,
    enableJira,
    sethandleClick,
    saveProduct,
  } = props;
  const [buttonColor, setButtonColor] = useState<string | undefined>("#042e5b");
  const [buttonTextColor, setBtnTextColor] = useState<string | undefined>(
    "#ffffff"
  );
  const [colorSelect, setColorSelect] = useState<string | undefined>(
    "please select"
  );
  const [fontSelect, setFontSelect] = useState<string | undefined>(
    "Arial,sans-serif"
  );
  // const [isCustomFont, setIsCustomFont] = useState<Boolean | undefined>(false);
  const [isCustomPos, setIsCustomPos] = useState<boolean | undefined>(false);
  const [customFont, setCustomFont] = useState<string | undefined>("");
  const [fontWeight, setFontWeight] = useState<number | undefined>(400);
  const [fontStyle, setFontStyle] = useState<string | undefined>("normal");
  const [btnPosition, setBtnPosition] = useState<string>(POS_RIGHT_MIDDLE);
  // const [btnPositionValue, setBtnPositionValue] = useState("");
  const [rotation, setRotation] = useState<string | undefined>("90");
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [icon, setIcon] = useState<any | null>(null);
  const [xmlCode, setXmlCode] = useState<any | null>(null);
  const [base64, setBase64] = useState<any | null>(null);
  const [generalComment, setGeneralComment] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [buttonText, setButtonText] = useState<string | undefined>("Feedback");

  const [borderRadius, setBorderRadius] = useState("4px");
  const [customTop, setCustomTop] = useState("50%");
  const [customBottom, setCustomBottom] = useState("auto");
  const [customLeft, setCustomLeft] = useState("auto");
  const [customRight, setCustomRight] = useState("0");
  const [margin, setMargin] = useState("0");
  const [padding, setPadding] = useState("10px");
  const [transformOrigin, setTransformOrigin] = useState("46px 18px");
  const {
    userInfo,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    EmailSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    ExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    WidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    setQRSettingsAccordianContext,
  } = useContext(UserContext) as UserLoginInfo;
  const [isLoading, setIsLoading] = useState(false);

  const handleMainBtnFont = (event: any) => {
    if (typeof event === "string") {
      if (productParams) {
        const temp: IProductParams | undefined = cloneDeep(productParams);
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel
        ) {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.font = event;
          setProductParams(temp);
        }
      }
    } else {
      if (productParams) {
        const temp: IProductParams | undefined = cloneDeep(productParams);
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].feedbackAgentSettings &&
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel
        ) {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.font =
            event.target.value;
          setProductParams(temp);
        }
      }
    }
  };

  const handleMainBtnFontWeight = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel.fontWeight =
          event;
        setProductParams(temp);
      }
    }
  };

  const handleMainBtnColor = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        if (typeof event === "string") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.bgColor =
            event;
          setProductParams(temp);
        } else {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.bgColor =
            event.target.value;
          setProductParams(temp);
        }
      }
    }
  };

  const handleMainBtnPosition = (id: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel.position = id;
        setProductParams(temp);
      }
    }
  };

  const handleMainBtnRotation = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel.rotation =
          event;
        setProductParams(temp);
      }
    }
  };

  const handleMainBtnTextColor = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        if (typeof event === "string") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.fgColor =
            event;
          setProductParams(temp);
        } else {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.fgColor =
            event.target.value;
          setProductParams(temp);
        }
      }
    }
  };

  const handleMainBtnCustom = (event: any, key: ICustomProperties) => {
    const property = event.target.value;
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        if (!temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom) {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom = {};
        }
        if ((key as string) === "top") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.top =
            property;
          setProductParams(temp);
        } else if ((key as string) === "bottom") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.bottom =
            property;
          setProductParams(temp);
        } else if ((key as string) === "right") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.right =
            property;
          setProductParams(temp);
        } else if ((key as string) === "left") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.left =
            property;
          setProductParams(temp);
        } else if ((key as string) === "borderRadius") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.borderRadius =
            property;
          setProductParams(temp);
        } else if ((key as string) === "rotation") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.rotation =
            property;
          setProductParams(temp);
        } else if ((key as string) === "margin") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.margin =
            property;
          setProductParams(temp);
        } else if ((key as string) === "padding") {
          temp.products[0].feedbackAgentSettings.widgetLookAndFeel.custom.padding =
            property;
          setProductParams(temp);
        }
      }
    }
  };

  const handleMainBtnFontStyle = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel.fontStyle =
          event;
        setProductParams(temp);
      }
    }
  };

  const handleFontChange = (event: any) => {
    setFontSelect(event.target.value);
    handleMainBtnFont(event);
  };

  // const handleCustomFont = (event: any) => {
  // 	setCustomFont(event.target.value);
  // 	// handleMainBtnFont(event);
  // };

  const handleFontWeight = (event: any) => {
    setFontWeight(event.target.value);
    handleMainBtnFontWeight(event.target.value);
  };

  const handleMainBtnTitleChange = (event: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel
      ) {
        temp.products[0].feedbackAgentSettings.widgetLookAndFeel.text =
          event.target.value;
        setProductParams(temp);
      }
    }
  };

  const handleFontStyle = (event: any) => {
    setFontStyle(event.target.value);
    handleMainBtnFontStyle(event.target.value);
  };

  const buttonPositionlist = [
    { id: POS_RIGHT_MIDDLE, name: "right - middle" },
    { id: POS_RIGHT_BOTTOM, name: "right - bottom" },
    { id: POS_LEFT_MIDDLE, name: "left - middle" },
    { id: POS_LEFT_BOTTOM, name: "left - bottom" },
    { id: POS_BOTTOM_RIGHT, name: "bottom - right" },
    { id: POS_BOTTOM_LEFT, name: "bottom - left" },
    { id: POS_CUSTOM, name: "custom" },
  ];

  const [feedbackChip, setFeedbackChip] = React.useState(buttonPositionlist);
  const [selectedFeedback, setSelectedFeedback] = React.useState<any>();

  function feedbackRatingChanged(id: any) {
    // const newSet = new Set(selectedFeedback);
    // if (newSet.has(id)) newSet.delete(id);
    // else newSet.add(id);
    setSelectedFeedback(id);
  }

  const handleBtnPosition = (id: any) => {
    const selectedPosition = id;
    if (selectedPosition === POS_RIGHT_MIDDLE) {
      setRotation("90");
      handleMainBtnRotation("90");
      handleMainBtnPosition(id);
      setBtnPosition(selectedPosition);
      setIsCustomPos(false);
      setCustomTop("50%");
      setCustomBottom("auto");
      setCustomLeft("auto");
      setCustomRight("0");
      setTransformOrigin("46px 18px");
      setMargin("0");
    } else if (selectedPosition === POS_RIGHT_BOTTOM) {
      setRotation("90");
      setBtnPosition(selectedPosition);
      handleMainBtnRotation("90");
      handleMainBtnPosition(id);
      setIsCustomPos(false);
      setCustomTop("auto");
      setCustomBottom("0");
      setCustomLeft("auto");
      setCustomRight("0");
      setTransformOrigin("53px 10px");
      setMargin("0");
    } else if (selectedPosition === POS_LEFT_MIDDLE) {
      setRotation("270");
      handleMainBtnRotation("270");
      handleMainBtnPosition(id);
      setBtnPosition(selectedPosition);
      setIsCustomPos(false);
      setCustomTop("50%");
      setCustomBottom("auto");
      setCustomLeft("0");
      setCustomRight("auto");
      setTransformOrigin("18px 18px");
      setMargin("0");
    } else if (selectedPosition === POS_LEFT_BOTTOM) {
      setRotation("270");
      setBtnPosition(selectedPosition);
      handleMainBtnRotation("270");
      handleMainBtnPosition(id);
      setIsCustomPos(false);
      setCustomTop("auto");
      setCustomBottom("0");
      setCustomLeft("0");
      setCustomRight("auto");
      setTransformOrigin("10px 11px");
      setMargin("0");
    } else if (selectedPosition === POS_BOTTOM_RIGHT) {
      setRotation("0");
      handleMainBtnRotation("0");
      handleMainBtnPosition(id);
      setBtnPosition(selectedPosition);
      setIsCustomPos(false);
      setCustomTop("auto");
      setCustomBottom("0");
      setCustomLeft("auto");
      setCustomRight("0");
      setTransformOrigin("unset");
      setMargin("0");
    } else if (selectedPosition === POS_BOTTOM_LEFT) {
      setRotation("0");
      handleMainBtnRotation("0");
      handleMainBtnPosition(id);
      setBtnPosition(selectedPosition);
      setIsCustomPos(false);
      setCustomTop("auto");
      setCustomBottom("0");
      setCustomLeft("0");
      setCustomRight("auto");
      setTransformOrigin("unset");
      setMargin("0");
    } else if (selectedPosition === POS_CUSTOM) {
      // setRotation("0");
      // handleMainBtnRotation('0');
      setBtnPosition(selectedPosition);
      handleMainBtnPosition(id);
      setIsCustomPos(true);
    }
  };

  const handleCustomPosition = (event: any, key: any) => {
    const value = event.target.value;
    handleMainBtnCustom(event, key);
    if ((key as string) === "top") {
      setCustomTop(value);
    } else if ((key as string) === "bottom") {
      setCustomBottom(value);
    } else if ((key as string) === "right") {
      setCustomRight(value);
    } else if ((key as string) === "left") {
      setCustomLeft(value);
    } else if ((key as string) === "borderRadius") {
      setBorderRadius(value);
    } else if ((key as string) === "rotation") {
      setRotation(value);
      handleMainBtnRotation(value);
    } else if ((key as string) === "margin") {
      setMargin(value);
    } else if ((key as string) === "padding") {
      setPadding(value);
    }
  };

  const [widgetShow, setWidgetShow] = useState({
    widgetInfo: {
      widget: false,
      buttonColor,
      buttonTextColor,
      fontSelect,
      fontWeight,
      fontStyle,
      rotation,
      borderRadius,
      customTop,
      customBottom,
      customLeft,
      customRight,
      btnPosition,
      icon,
      margin,
      padding,
      buttonText,
      transformOrigin,
    },
  });

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
    ) {
      setButtonColor(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .bgColor
      );
      setBtnTextColor(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .fgColor
      );
      setFontSelect(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel.font
      );
      setFontWeight(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .fontWeight
      );
      setFontStyle(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .fontStyle
      );
      setButtonText(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel.text
      );
      setBtnPosition(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .position
      );
      setRotation(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .rotation
      );
      setIcon(
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel.icon
      );
      if (
        productParams.products[0].feedbackAgentSettings.widgetLookAndFeel
          .position === "CUSTOM"
      ) {
        setIsCustomPos(true);
      }
    }
  }, [productParams]);

  useEffect(() => {
    setWidgetShow({
      ...widgetShow,
      widgetInfo: {
        ...widgetShow.widgetInfo,
        buttonColor,
        buttonTextColor,
        fontSelect,
        fontWeight,
        fontStyle,
        rotation,
        borderRadius,
        customTop,
        customBottom,
        customLeft,
        customRight,
        btnPosition,
        icon,
        margin,
        padding,
        buttonText,
        transformOrigin,
      },
    });
  }, [
    buttonColor,
    buttonTextColor,
    fontSelect,
    fontWeight,
    fontStyle,
    rotation,
    borderRadius,
    customTop,
    customBottom,
    customLeft,
    icon,
    customRight,
    btnPosition,
    margin,
    padding,
    buttonText,
    transformOrigin,
  ]);

  useEffect(() => {
    setWidgetVal(widgetShow);
  }, [widgetShow]);

  const selectedTab = (e: any) => {
    appLogger.info({
      infoObj: {
        method: "selectedTab",
        component: "add-product",
        fileName: "widgetAppearance.tsx",
        event: e,
      },
    });
    setWidgetShow({
      ...widgetShow,
      widgetInfo: {
        ...widgetShow.widgetInfo,
        widget: true,
      },
    });
  };

  const closeTab = () => {
    setWidgetShow({
      ...widgetShow,
      widgetInfo: {
        ...widgetShow.widgetInfo,
        widget: false,
      },
    });
  };

  const [isbtnColorPalleteOpen, setbtnColortoggle] = useState(false);
  const [isbtnColorTextPalleteOpen, setbtnTxtColortoggle] = useState(false);

  const btncolorpalleteclose = useCallback(() => setbtnColortoggle(false), []);
  const btntxtcolorpalleteclose = useCallback(
    () => setbtnTxtColortoggle(false),
    []
  );

  const btncolorPalletepopover = useRef<any>(null);
  useClickOutside(btncolorPalletepopover, btncolorpalleteclose);

  const btntextcolorPalletepopover = useRef<any>(null);
  useClickOutside(btntextcolorPalletepopover, btntxtcolorpalleteclose);

  const scroll = (e: any) => {
    e.stopPropagation();
    setScroll("widget");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(2);
  };
  const previewscroll = (e: any) => {
    e.stopPropagation();
    setpreviewScroll("widget");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(1);
  };
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    appLogger.info({
      infoObj: {
        method: "handleAccordianChange",
        component: "add-product",
        fileName: "widgetAppearance.tsx",
        accordianChangesData: { value, type },
      },
    });
    setGenSettingsAccordianContext(false);
    setBasicDetailAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(false);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(false);
    setWidgAppSettingsAccordianContext(value);
    setWidgIntgSettingsAccordianContext(false);
    setQRSettingsAccordianContext(false);
    if (clickType == "next") {
      setWidgIntgSettingsAccordianContext(true);
      setWidgAppSettingsAccordianContext(false);
    }
    if (clickType == "back") {
      setWidgAppSettingsAccordianContext(false);
      if (productParams?.products?.[0]?.platform == PLATFORM_TYPE_TV) {
        setQRSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        ) &&
        enableJira &&
        enabledFeatures?.enableJira
      ) {
        setExttrackingSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        ) &&
        enableJira &&
        enabledFeatures?.enableJira
      ) {
        setExttrackingSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        ) &&
        enableJira &&
        enabledFeatures?.enableJira
      ) {
        setExttrackingSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        )
      ) {
        setFreqSettingsAccordianContext(true);
        // setEmailSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        setBugSettingsAccordianContext(true);
        // setEmailSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        // setEmailSettingsAccordianContext(true);
        setFbSettingsAccordianContext(true);
      } else {
        setGenSettingsAccordianContext(true);
      }
    }
    if (clickType === "create") {
      setIsLoading(true);
      setWidgAppSettingsAccordianContext(false);
      saveProduct("create");
      setWidgIntgSettingsAccordianContext(true);
    }
  };
  const renderPreviuosBtnToolTip = () => {
    let tooltip: any = "";

    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      ) &&
      enableJira &&
      enabledFeatures?.enableJira
    ) {
      tooltip = "Go to Tracking System Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      ) &&
      enableJira &&
      enabledFeatures?.enableJira
    ) {
      tooltip = "Go to Tracking System Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      ) &&
      enableJira &&
      enabledFeatures?.enableJira
    ) {
      tooltip = "Go to Tracking System Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams?.products[0].platform == PLATFORM_TYPE_TV
    ) {
      tooltip = "Go to QR Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      )
    ) {
      tooltip = "Go to Feature Request Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      )
    ) {
      tooltip = "Go to Ticket Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      tooltip = "Go to Feedback Settings";
    } else {
      tooltip = "Go to General Settings";
    }
    return tooltip;
  };
  return (
    <Accordion
      expanded={WidgAppSettingsAccordianContext}
      onChange={(e, expanded) => {
        if (expanded) {
          selectedTab(e);
          handleAccordianChange(expanded, "basicDetails", "accordian");
        } else {
          closeTab();
          handleAccordianChange(expanded, "basicDetails", "accordian");
        }
      }}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            Widget Appearance
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="Widget Appearance Help" placement="bottom">
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} onClick={scroll} />
            </Tooltip>
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip title="Feedback Button Preview" placement="bottom">
              <PreviewIcon
                sx={{ mx: 1, fontSize: "20px" }}
                onClick={previewscroll}
              />
            </Tooltip>{" "}
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        {productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].platform != PLATFORM_TYPE_TV ? (
          <>
            <Grid container className="widgt-appearance-section" spacing={2}>
              <Grid item spacing={2} className="acc-prod-icon">
                Widget Appearance
              </Grid>
              <IconUpload
                iconStr={
                  productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].feedbackAgentSettings &&
                  productParams.products[0].feedbackAgentSettings
                    .widgetLookAndFeel &&
                  productParams.products[0].feedbackAgentSettings
                    .widgetLookAndFeel.icon
                    ? productParams.products[0].feedbackAgentSettings
                        .widgetLookAndFeel.icon
                    : ""
                }
                label="Icon for the feedback button"
                iconType={MAIN_BUTTON}
                productParams={productParams}
                setProductParams={setProductParams}
              />

              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Text to display on the feedback button:
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={
                      productParams &&
                      productParams.products &&
                      productParams.products[0] &&
                      productParams.products[0].feedbackAgentSettings &&
                      productParams.products[0].feedbackAgentSettings
                        .widgetLookAndFeel
                        ? productParams.products[0].feedbackAgentSettings
                            .widgetLookAndFeel.text
                        : ""
                    }
                    onChange={(event) => handleMainBtnTitleChange(event)}
                    id="feedback-select"
                    label="feedback"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>Choose font for feedback button text:</InputLabel>
                  <OutlinedInput
                    type="text"
                    id="flow-select"
                    value={fontSelect}
                    label="flow"
                    onChange={(e) => handleFontChange(e)}
                  ></OutlinedInput>
                  {/* <Select
                    labelId="flow-select"
                    id="flow-select"
                    value={fontSelect}
                    label="flow"
                    onChange={(e) => handleFontChange(e)}
                  >
                    <MenuItem key={1} value={"inherit"}>
                      {"inherit (styling from your site)"}
                    </MenuItem>
                    <MenuItem key={2} value={"Arial,sans-serif"}>
                      {"Arial (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={3} value={"Verdana,sans-serif"}>
                      {"Verdana (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={4} value={"Helvetica,sans-serif"}>
                      {"Helvetica (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={5} value={"Tahoma,sans-serif"}>
                      {"Tahoma (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={6} value={"Trebuchet,sans-serif"}>
                      {"Trebuchet (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={7} value={"Times New Roman,sans-serif"}>
                      {"Times New Roman (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={8} value={"Georgia,serif"}>
                      {"Georgia (serif)"}
                    </MenuItem>
                    <MenuItem key={9} value={"Garamond,serif"}>
                      {"Garamond (serif)"}
                    </MenuItem>
                    <MenuItem key={10} value={"Courier New,monospace"}>
                      {"Courier New (monospace)"}
                    </MenuItem>
                    <MenuItem key={11} value={"Brush Script MT,cursive"}>
                      {"Brush Script MT(cursive)"}
                    </MenuItem>
                    <MenuItem key={12} value={"Monaco, sans-serif"}>
                      {"Monaco (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={13} value={"Andale Mono, sans-serif"}>
                      {"Andale Mono (sans-serif)"}
                    </MenuItem>
                    <MenuItem key={14} value={"Open Sans, sans-serif"}>
                      {"Open Sans (sans-serif)"}
                    </MenuItem>
                  </Select> */}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Choose font weight for feedback button text:
                  </InputLabel>
                  <Select
                    name={`select_fontWeight`}
                    value={fontWeight}
                    onChange={(event) => {
                      handleFontWeight(event);
                    }}
                  >
                    <MenuItem key={1} value={100}>
                      {"lighter"}
                    </MenuItem>
                    <MenuItem key={2} value={400}>
                      {"normal"}
                    </MenuItem>
                    <MenuItem key={3} value={500}>
                      {"bold"}
                    </MenuItem>
                    <MenuItem key={4} value={900}>
                      {"bolder"}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Choose font style for feedback button text
                  </InputLabel>
                  <Select
                    name={`select_fontStyle`}
                    value={fontStyle}
                    onChange={(event) => {
                      handleFontStyle(event);
                    }}
                  >
                    <MenuItem key={1} value={"normal"}>
                      {"normal"}
                    </MenuItem>
                    <MenuItem key={2} value={"italic"}>
                      {"italic"}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginBottom: "0",
                  }}
                >
                  {/* <Typography className="title-sm" id={`colorStylingOptions`}>
                  Choose button color:
                  <div style={{ display: "inline-block", color: "red" }}>*</div>
                </Typography> */}

                  <div className="pickerColorDiv">
                    <Grid container sx={{ marginTop: 0 }}>
                      <Grid xs={2}>
                        <div
                          className="swatch"
                          style={{ backgroundColor: buttonColor }}
                          onClick={() => setbtnColortoggle(true)}
                        />
                      </Grid>
                      <Grid xs={10}>
                        <div>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>Feedback Button Color </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={buttonColor}
                              label="Button Color"
                              onChange={(event) => {
                                setButtonColor(event.target.value);
                                handleMainBtnColor(event.target.value);
                              }}
                              onFocus={(event) => {
                                setbtnColortoggle(true);
                              }}
                            />
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                    {isbtnColorPalleteOpen && (
                      <div className="popoverpick" ref={btncolorPalletepopover}>
                        {/* <CloseIcon
                        className="cursor-pointer picker-close"
                        onClick={() => btncolorpalleteclose()}
                      /> */}
                        <div
                          className="cursor-pointer picker-close"
                          onClick={() => btncolorpalleteclose()}
                        >
                          Close
                        </div>
                        <ChromePicker
                          color={buttonColor}
                          onChange={(color) => {
                            setButtonColor(color.hex);
                            handleMainBtnColor(color.hex);
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {/* <Typography className="title-sm" id={`colorStylingOptions`}>
                  Choose text color:
                  <div style={{ display: "inline-block", color: "red" }}>*</div>
                </Typography> */}
                </Box>
              </Grid>
              <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: "100%",
                    marginBottom: "0",
                  }}
                >
                  <div className="pickerColorDiv">
                    <Grid container sx={{ marginTop: 0 }}>
                      <Grid xs={2}>
                        <div
                          className="swatch"
                          style={{ backgroundColor: buttonTextColor }}
                          onClick={() => setbtnTxtColortoggle(true)}
                        />
                      </Grid>
                      <Grid xs={10}>
                        <div>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Feedback Button's Text Color{" "}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={buttonTextColor}
                              label="Text Color"
                              onChange={(event) => {
                                setBtnTextColor(event.target.value);
                                handleMainBtnTextColor(event.target.value);
                              }}
                              onFocus={(event) => {
                                setbtnTxtColortoggle(true);
                              }}
                            />
                          </FormControl>
                        </div>
                      </Grid>
                    </Grid>
                    {isbtnColorTextPalleteOpen && (
                      <div
                        className="popoverpick"
                        ref={btntextcolorPalletepopover}
                      >
                        {/* <CloseIcon
        className="cursor-pointer picker-close"
        onClick={() => btntxtcolorpalleteclose()}
      /> */}
                        <div
                          className="cursor-pointer picker-close"
                          onClick={() => btntxtcolorpalleteclose()}
                        >
                          Close
                        </div>
                        <ChromePicker
                          color={buttonTextColor}
                          onChange={(color: any) => {
                            setBtnTextColor(color.hex);
                            handleMainBtnTextColor(color.hex);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </Box>
              </Grid>

              <Grid item className="ratings-chip" xs={12}>
                <Box
                  sx={{
                    margin: "5px",
                  }}
                >
                  <Typography
                    className="title-sm"
                    id={`positionStylingOptions`}
                  >
                    Button position:{" "}
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </Typography>
                  {feedbackChip.map((e: any) => (
                    <Chip
                      key={e.id}
                      onClick={() => handleBtnPosition(e.id)}
                      variant={
                        productParams &&
                        productParams.products[0] &&
                        productParams.products[0].feedbackAgentSettings &&
                        productParams.products[0].feedbackAgentSettings
                          .widgetLookAndFeel &&
                        productParams.products[0].feedbackAgentSettings
                          .widgetLookAndFeel.position &&
                        productParams.products[0].feedbackAgentSettings
                          .widgetLookAndFeel.position === e.id
                          ? "filled"
                          : "outlined"
                      }
                      label={e.name}
                      color="primary"
                    />
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12}>
                {isCustomPos ? (
                  <Typography sx={{ fontSize: "13px", mb: 2 }}>
                    If more specific positioning is required, feel free to add
                    properties below. Empty fields will not be applied
                  </Typography>
                ) : null}
                {isCustomPos ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Top </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.top
                              : ""
                          }
                          label="percentage"
                          onChange={(event) =>
                            handleCustomPosition(event, "top")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Bottom </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.bottom
                              : ""
                          }
                          label="percentage"
                          onChange={(event) =>
                            handleCustomPosition(event, "bottom")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Right </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.right
                              : ""
                          }
                          label="percentage"
                          onChange={(event) =>
                            handleCustomPosition(event, "right")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Left </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.left
                              : ""
                          }
                          label="percentage"
                          onChange={(event) =>
                            handleCustomPosition(event, "left")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Border Radius </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.borderRadius
                              : ""
                          }
                          label="pixels or percentage"
                          onChange={(event) =>
                            handleCustomPosition(event, "borderRadius")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Rotation </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.rotation
                              : ""
                          }
                          label={"0 - 360"}
                          onChange={(event) =>
                            handleCustomPosition(event, "rotation")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Margin </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.margin
                              : ""
                          }
                          label={"pixels"}
                          onChange={(event) =>
                            handleCustomPosition(event, "margin")
                          }
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>Padding </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel.custom
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.custom.padding
                              : ""
                          }
                          label={"pixels"}
                          onChange={(event) =>
                            handleCustomPosition(event, "padding")
                          }
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
            <Divider sx={{ my: 1 }} />
            <BrandingAgent
              setProductParams={setProductParams}
              productParams={productParams}
            />
          </>
        ) : (
          <>
            {productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0].technology == "rokuTv" && (
                <>
                  <Grid
                    container
                    className="widgt-appearance-section"
                    spacing={2}
                  >
                    <Grid item xs={12} className="acc-prod-icon">
                      Widget Appearance
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                      <FormControl className="custom-select" fullWidth>
                        <InputLabel>
                          Text to display on the feedback button:
                          <div
                            style={{ display: "inline-block", color: "red" }}
                          >
                            *
                          </div>
                        </InputLabel>
                        <OutlinedInput
                          type="text"
                          value={
                            productParams &&
                            productParams.products &&
                            productParams.products[0] &&
                            productParams.products[0].feedbackAgentSettings &&
                            productParams.products[0].feedbackAgentSettings
                              .widgetLookAndFeel
                              ? productParams.products[0].feedbackAgentSettings
                                  .widgetLookAndFeel.text
                              : ""
                          }
                          onChange={(event) => handleMainBtnTitleChange(event)}
                          id="feedback-select"
                          label="feedback"
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          width: "100%",
                          marginBottom: "0",
                        }}
                      >
                        {/* <Typography className="title-sm" id={`colorStylingOptions`}>
                  Choose button color:
                  <div style={{ display: "inline-block", color: "red" }}>*</div>
                </Typography> */}

                        <div className="pickerColorDiv">
                          <Grid container sx={{ marginTop: 0 }}>
                            <Grid xs={2}>
                              <div
                                className="swatch"
                                style={{ backgroundColor: buttonColor }}
                                onClick={() => setbtnColortoggle(true)}
                              />
                            </Grid>
                            <Grid xs={10}>
                              <div>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Feedback Button Color{" "}
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={buttonColor}
                                    label="Button Color"
                                    onChange={(event) => {
                                      setButtonColor(event.target.value);
                                      handleMainBtnColor(event.target.value);
                                    }}
                                    onFocus={(event) => {
                                      setbtnColortoggle(true);
                                    }}
                                  />
                                </FormControl>
                              </div>
                            </Grid>
                          </Grid>
                          {isbtnColorPalleteOpen && (
                            <div
                              className="popoverpick"
                              ref={btncolorPalletepopover}
                            >
                              {/* <CloseIcon
                        className="cursor-pointer picker-close"
                        onClick={() => btncolorpalleteclose()}
                      /> */}
                              <div
                                className="cursor-pointer picker-close"
                                onClick={() => btncolorpalleteclose()}
                              >
                                Close
                              </div>
                              <ChromePicker
                                color={buttonColor}
                                onChange={(color) => {
                                  setButtonColor(color.hex);
                                  handleMainBtnColor(color.hex);
                                }}
                              />
                            </div>
                          )}
                        </div>
                        {/* <Typography className="title-sm" id={`colorStylingOptions`}>
                  Choose text color:
                  <div style={{ display: "inline-block", color: "red" }}>*</div>
                </Typography> */}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ marginTop: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          width: "100%",
                          marginBottom: "0",
                        }}
                      >
                        <div className="pickerColorDiv">
                          <Grid container sx={{ marginTop: 0 }}>
                            <Grid xs={2}>
                              <div
                                className="swatch"
                                style={{ backgroundColor: buttonTextColor }}
                                onClick={() => setbtnTxtColortoggle(true)}
                              />
                            </Grid>
                            <Grid xs={10}>
                              <div>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Feedback Button's Text Color{" "}
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={buttonTextColor}
                                    label="Text Color"
                                    onChange={(event) => {
                                      setBtnTextColor(event.target.value);
                                      handleMainBtnTextColor(
                                        event.target.value
                                      );
                                    }}
                                    onFocus={(event) => {
                                      setbtnTxtColortoggle(true);
                                    }}
                                  />
                                </FormControl>
                              </div>
                            </Grid>
                          </Grid>
                          {isbtnColorTextPalleteOpen && (
                            <div
                              className="popoverpick"
                              ref={btntextcolorPalletepopover}
                            >
                              {/* <CloseIcon
        className="cursor-pointer picker-close"
        onClick={() => btntxtcolorpalleteclose()}
      /> */}
                              <div
                                className="cursor-pointer picker-close"
                                onClick={() => btntxtcolorpalleteclose()}
                              >
                                Close
                              </div>
                              <ChromePicker
                                color={buttonTextColor}
                                onChange={(color: any) => {
                                  setBtnTextColor(color.hex);
                                  handleMainBtnTextColor(color.hex);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                  <Divider sx={{ my: 1 }} />
                  <BrandingAgent
                    setProductParams={setProductParams}
                    productParams={productParams}
                  />
                </>
              )}
            {productParams &&
              productParams.products &&
              productParams.products[0] &&
              productParams.products[0].technology != "rokuTv" && (
                <>
                  <BrandingAgent
                    setProductParams={setProductParams}
                    productParams={productParams}
                  />
                </>
              )}
          </>
        )}
        {/* <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>Choose Widget position on site:</InputLabel>
              <Select
                // disabled={isCustomPos ? true : false}
                name={`select_position`}
                value={btnPosition}
                onChange={(event) => {
                  handleBtnPosition(event);
                }}
              >
                <MenuItem key={1} value={POS_RIGHT_MIDDLE}>
                  {"Right - Middle"}
                </MenuItem>
                <MenuItem key={2} value={POS_RIGHT_BOTTOM}>
                  {"Right - Bottom"}
                </MenuItem>
                <MenuItem key={3} value={POS_LEFT_MIDDLE}>
                  {"Left - Middle"}
                </MenuItem>
                <MenuItem key={4} value={POS_LEFT_BOTTOM}>
                  {"Left - Bottom"}
                </MenuItem>
                <MenuItem key={5} value={POS_BOTTOM_LEFT}>
                  {"Bottom - Left"}
                </MenuItem>
                <MenuItem key={6} value={POS_BOTTOM_RIGHT}>
                  {"Bottom - Right"}
                </MenuItem>
                <MenuItem key={7} value={POS_CUSTOM}>
                  {"Custom"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid> */}

        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title={renderPreviuosBtnToolTip()} placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "basicDetails", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>{renderPreviuosBtnToolTip()}</span>
            </Button>
          </Tooltip>
          {productParams &&
          productParams.products &&
          productParams.products[0] &&
          productParams.products[0].id ? (
            <Tooltip title="Go to Integration Steps" placement="bottom">
              <Button
                size="small"
                className="nextbtn"
                onClick={(e: any) => {
                  handleAccordianChange(true, "basicDetails", "next");
                }}
              >
                &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
                <span>Go to Integration Steps</span>
                <KeyboardArrowRight />
              </Button>
            </Tooltip>
          ) : (
            <>
              {" "}
              <Tooltip title="" placement="bottom">
                <Button
                  size="small"
                  className="nextbtn"
                  onClick={(e: any) => {
                    handleAccordianChange(true, "basicDetails", "create");
                  }}
                >
                  &nbsp;
                  <span className="acc-prod-next-span">Create</span>
                  &nbsp; <span></span>
                  <KeyboardArrowRight />
                </Button>
              </Tooltip>
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default WidgetAppearance;
